import React, { useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import 'intersection-observer'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperStyle from '../../components/style/SwiperStyle'
import { getUseParams, setUrl } from '../../utils/baseUtil'
import { dateDiff } from '../../utils/dateUtil'

const permissionMap = {
  1: { label: '免费', bgColor: 'bg-c-84bfff-339aff' },
  2: { label: '邀约', bgColor: 'bg-c-84bfff-339aff' },
  3: { label: '付费', bgColor: 'bg-c-cb8839-f0d5af' }
}

let topHeight = 0
let distanceList = []
let topNavHeight = 0
let afterHeight = 0

const ScrollAnchor = (props) => {
  const location = useLocation()
  const query = getUseParams(location.search)

  const [isFixed, setIsFixed] = useState(false)
  const [navActiveIndex, setNavActiveIndex] = useState(0)

  const navRef = useRef(null)
  const swiperRef = useRef(null)

  const setLastHeight = () => {
    const topicArticleListHeight = window.innerHeight - topNavHeight - topHeight - afterHeight
    const topicArticleListBoxes = document.querySelectorAll('.collection-list-content')
    const lastTopicArticle =
      topicArticleListBoxes.length > 0 ? topicArticleListBoxes[topicArticleListBoxes.length - 1] : null
    const lastTopicArticleHeight = lastTopicArticle ? lastTopicArticle.offsetHeight : 0
    const lastTopicArticleBottom = document.querySelector('.collection-list-end')
    const lastTopicArticleBottomHeight = lastTopicArticleBottom ? lastTopicArticleBottom.offsetHeight : 0
    if (lastTopicArticle) {
      const lastTopicArticleAdBox = lastTopicArticle.nextElementSibling
      if (lastTopicArticleAdBox && lastTopicArticleAdBox.classList.contains('collection-ad-box')) {
        const lastTopicArticleAdBoxHeight = lastTopicArticleAdBox.offsetHeight
        if (
          lastTopicArticleHeight + lastTopicArticleAdBoxHeight + lastTopicArticleBottomHeight <
          topicArticleListHeight
        ) {
          lastTopicArticleBottom.style.height = `${
            topicArticleListHeight - lastTopicArticleHeight - lastTopicArticleAdBoxHeight
          }px`
        }
      } else {
        if (lastTopicArticleHeight + lastTopicArticleBottomHeight < topicArticleListHeight) {
          lastTopicArticleBottom.style.height = `${topicArticleListHeight - lastTopicArticleHeight}px`
        }
      }
    }
  }

  const handleScroll = () => {
    const scrollTop = window.scrollY
    if (navRef.current) {
      const navRect = navRef.current.getBoundingClientRect()
      setIsFixed(navRect.top - topHeight <= 0)
    }
    for (var i = 0; i < distanceList.length; i++) {
      if (scrollTop >= distanceList[i][0] && scrollTop < distanceList[i][1]) {
        swiperRef.current?.swiper.slideTo(i, 0, false)
        setNavActiveIndex(i)
      }
    }
  }

  useEffect(() => {
    topHeight = document.querySelector('.share-openapp-wrap')?.offsetHeight || 0
    topNavHeight = document.querySelector('.collection-nav-box')?.offsetHeight || 0

    const afterStyle = window.getComputedStyle(document.querySelector('body'), '::after')
    if (afterStyle.content !== 'none') {
      const height = parseInt(afterStyle.height)
      const paddingBottom = parseInt(afterStyle.paddingBottom)
      afterHeight = height + paddingBottom
    }

    const topicListBottomImages = document.querySelectorAll('.collection-list-bottom-image')
    if (topicListBottomImages.length > 0) {
      topicListBottomImages.forEach((image) => {
        image.addEventListener('load', () => {
          setLastHeight()
        })
      })
    } else {
      setLastHeight()
    }

    const listBox = document.querySelectorAll('.collection-list-content')
    listBox.forEach((box) => {
      const listoffsetTop = box.offsetTop - topNavHeight - topHeight
      const nextElement = box.nextElementSibling
      if (nextElement && nextElement.classList.contains('topic-ad-box')) {
        distanceList.push([listoffsetTop, listoffsetTop + box.offsetHeight + nextElement.offsetHeight])
      } else {
        distanceList.push([listoffsetTop, listoffsetTop + box.offsetHeight])
      }
    })

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const handleScrollTo = (id) => {
    const targetElement = document.getElementById(id)
    const commonTopBoxHeight = document.querySelector('.share-openapp-wrap')?.offsetHeight || 0
    const topicNavBoxHeight = document.querySelector('.collection-nav-box')?.offsetHeight || 0
    if (targetElement) {
      const offsetTop = targetElement.offsetTop - commonTopBoxHeight - topicNavBoxHeight
      window.scrollTo({ top: offsetTop })
    }
  }

  const setTelegraphItem = (item) => {
    return (
      <a
        key={item.tid}
        className="d-f b-m-w-14 m-t-20 m-b-20 collection-list-item"
        href={setUrl('telegraph.html', query, item.tid)}
      >
        <div className="f-g-1 d-f f-d-c o-h">
          <div className="f-g-1 m-b-20">
            <div className="o-h f-s-16 f-w-b l-h-1375 c-191c27 t-o-e l-c-3">{item.title || item.content || ''}</div>
          </div>
          <div className="d-f f-b-c o-h l-h-1">
            {/* <div className="f-g-1 d-f f-s-c o-h">
              <div className="o-h f-s-13 c-9ea5bb w-s-n t-o-el">{item.creator || item.from_source || ''}</div>
            </div> */}
            <div className="f-s-0 d-f f-e-c w-100p f-s-12 c-9ea5bb">
              <div>{dateDiff(item.create_time * 1000)}</div>
              {!!item.view_num && <div className="subject-top-list-read">{item.view_num}阅读</div>}
            </div>
          </div>
        </div>
      </a>
    )
  }

  const setArticleItem = (item) => {
    return (
      <a
        key={item.tid}
        className="d-f b-m-w-14 m-t-20 m-b-20 collection-list-item"
        href={setUrl('deepnews.html', query, item.tid)}
      >
        <div className="f-g-1 d-f f-d-c o-h">
          <div className="f-g-1 m-b-20">
            <div className="o-h f-s-16 f-w-b l-h-1375 c-191c27 t-o-e l-c-2">{item.title}</div>
          </div>
          <div className="d-f f-b-c o-h l-h-1">
            <div className="f-g-1 d-f f-s-c o-h">
              <div className="o-h f-s-13 c-9ea5bb w-s-n t-o-el">{item.creator || item.from_source || ''}</div>
            </div>
            <div className="f-s-0 d-f f-s-c f-s-12 c-9ea5bb">
              <div>{dateDiff(item.create_time * 1000)}</div>
              {!!item.view_num && <div className="subject-top-list-read">{item.view_num}阅读</div>}
            </div>
          </div>
        </div>
        {Array.isArray(item.img_list) && item.img_list[0] && (
          <div className="f-s-0 m-l-10 o-h collection-list-image">
            <img className="w-100p h-100p o-f-c" src={item.img_list[0]} alt="" />
          </div>
        )}
      </a>
    )
  }

  //1:未开始 2:直播中 3:直播结束 4:回放
  const statusIcon = {
    1: 'live-advance-835.png',
    2: '2025071/live-ing-2025071.png',
    3: 'live-end-835.png',
    4: 'live-playback-835.png'
  }
  const setLiveItem = (item) => {
    return (
      <a
        key={item.tid}
        className="d-f b-m-w-14 m-t-20 m-b-20 collection-list-item"
        href={setUrl('live.html', query, item.tid)}
      >
        <div className="f-g-1 d-f f-d-c o-h">
          <div className="f-g-1 m-b-20">
            <div className="o-h f-s-16 f-w-b l-h-1375 c-191c27 t-o-e l-c-2">{item.title}</div>
          </div>
          <div className="d-f f-b-c o-h l-h-1">
            {statusIcon[item.status] ? (
              <div className={`f-s-0 p-r d-f f-c-c m-r-5 ${item.status === 2 ? 'w-53' : 'w-48'}`}>
                <img className="w-100p h-100p o-f-c" src={`https://file.jingpt.com/wap/images/${statusIcon[item.status]}`} alt="" />
                {
                  item.status === 2 &&
                  <>
                  <div className="p-a t-50p w-2 h-10 bg-c-ff0027 t-o-c-b article-live-animation-1"></div>
                  <div className="p-a t-50p w-2 h-10 bg-c-ff0027 t-o-c-b article-live-animation-2"></div>
                  <div className="p-a t-50p w-2 h-10 bg-c-ff0027 t-o-c-b article-live-animation-3"></div>
                  </>
                }
              </div>
            ) : null}
            <div className="f-g-1 t-a-r w-s-n o-h f-s-12 c-9ea5bb">
              {dayjs(item.start_time * 1000).format('YYYY-MM-DD HH:mm')}
              {item.end_time &&
              dayjs(item.start_time * 1000).format('YYYY-MM-DD') === dayjs(item.end_time * 1000).format('YYYY-MM-DD')
                ? `-${dayjs(item.end_time * 1000).format('HH:mm')}`
                : ''}
            </div>
          </div>
        </div>
        {Array.isArray(item.img_list) && item.img_list[0] && (
          <div className="p-r f-s-0 m-l-10 o-h collection-list-image">
            <img className="w-100p h-100p o-f-c" src={item.img_list[0]} alt="" />
            <div
              className={`p-a t-a-c f-s-9 f-w-b c-fff ${
                permissionMap[item.permission]?.bgColor || ''
              } live-list-permission-tag`}
            >
              {permissionMap[item.permission]?.label || ''}
            </div>
          </div>
        )}
      </a>
    )
  }

  return (
    <>
      <section ref={navRef} className="p-r collection-nav-wrap">
        <SwiperStyle
          className={`${isFixed ? 'p-f m-w-480' : 'p-a m-c'} w-100p bg-c-fff collection-nav-box ${
            isFixed ? 'collection-nav-fixed-box' : ''
          }`}
        >
          <Swiper
            ref={swiperRef}
            className="o-h b-c-f5f5f5 collection-swiper-container"
            slidesPerView="auto"
            spaceBetween={20}
            resistanceRatio={0}
            initialSlide={0}
          >
            {props.data.map((item, index) => {
              return (
                <SwiperSlide
                  className={`p-r d-f f-s-c f-s-16 l-h-1 collection-nav ${
                    navActiveIndex === index ? 'collection-nav-active' : ''
                  }`}
                  key={item.topic_id}
                  onClick={() => {
                    if (!!swiperRef.current) {
                      swiperRef.current.swiper.slideTo(index, 0, false)
                      setNavActiveIndex(swiperRef.current.swiper.clickedIndex)
                      handleScrollTo(item.topic_id)
                    }
                  }}
                >
                  {item.title}
                </SwiperSlide>
              )
            })}
          </Swiper>
        </SwiperStyle>
      </section>
      <section>
        {Array.isArray(props.data) &&
          props.data.map((pItem, index) => (
            <div className="collection-list-box" key={pItem.topic_id}>
              {index > 0 && (
                <div className="b-p-w-14 f-s-16 l-h-114286 b-c-f4f6f8 collection-list-gap">{pItem.title}</div>
              )}
              <div
                id={pItem.topic_id}
                className={`collection-list-content ${
                  pItem.result_list?.length ? '' : 'collection-list-content-empty'
                }`}
              >
                {Array.isArray(pItem.result_list) && !!pItem.result_list.length
                  ? pItem.result_list.map((item) => {
                      if (item.belong === 1) {
                        return setTelegraphItem(item)
                      }
                      if (item.belong === 5) {
                        return setLiveItem(item)
                      }
                      return setArticleItem(item)
                    })
                  : null}
              </div>
            </div>
          ))}
        <div className="f-s-14 l-h-157143 c-9ea5bb t-a-c collection-list-end">已显示全部内容</div>
      </section>
    </>
  )
}

export default ScrollAnchor
